import { useState, useCallback } from 'react';
import { FetchElements } from "../../../../utils/js/request";
import { useNavigate } from "react-router-dom";
import {REQUEST} from "../../../../utils/js/Const";

export const useBakeryGroups = () => {
    const [groups, setGroups] = useState(null);
    const navigate = useNavigate();

    const getGroups = useCallback(async () => {

        const url = `${REQUEST}/api/v1/productions/groups`;

        return new Promise((resolve, reject) => {
            FetchElements(
                url,
                "GET",
                (responseData) => {
                    setGroups(responseData);
                    resolve(responseData);
                },
                navigate,
                2,
                () => navigate("/auth"),
                (title, message, statusCode) => {
                    const errorObj = { title, message, statusCode };
                    reject(errorObj);
                    console.error(`${title}: ${message}`);
                },
                0,
                null,
                [],
                false
            );
        });
    }, [navigate]);

    return { getGroups, groups };
};